import { useEffect, useState } from 'react';
import VisitorAPI from 'visitorapi';

import env from '@/configs/env';

const GEOLOCATION_KEY: string = '__geolocation';

export default function useGetGeolocation() {
  const [countryName, setCountryName] = useState<string>('');
  const [currencies, setCurrencies] = useState<string[]>([]);

  const localGeolocation: string | null = localStorage.getItem(GEOLOCATION_KEY);

  useEffect(() => {
    if (localGeolocation) {
      const { countryName, currencies, date } = JSON.parse(localGeolocation);
      const deltaTime = 1_000 * 60 * 60 * 24; // 5 days

      const recordDate = new Date(date).getTime();
      const limitDate = Date.now() - deltaTime;

      // If is on the limit, do not consult API, return the cached value
      if (limitDate < recordDate) {
        setCountryName(countryName);
        setCurrencies(currencies);
        return;
      }
    }

    VisitorAPI(env.VITE_VISITOR_API_KEY, ({ countryName, currencies }) => {
      setCountryName(countryName);
      setCurrencies(currencies);
      localStorage.setItem(
        GEOLOCATION_KEY,
        JSON.stringify({
          countryName,
          currencies,
          date: new Date(),
        })
      );
    });
  }, [localGeolocation]);

  return {
    geolocation: {
      country: countryName,
      currency: currencies?.[0],
    },
    isPendingGeolocation: !countryName || !currencies.length,
  };
}
